// The user's selected next-turn agent for a conversation — the composer's active
// agent, advanced by an explicit switch, by accepting a handoff suggestion, or by
// the agent picked at creation (so the first turn, which has no turns yet to
// derive a current agent from, still resolves one). Persisted in sessionStorage
// so the selection survives a refresh, then clears when the tab closes: this is
// transient next-turn intent, not a durable preference, so a much-later visit
// re-surfaces a pending suggestion fresh.
const nextTurnAgentStorageKey = (conversationId: string) => `next-turn-agent:${conversationId}`;

export const readNextTurnAgent = (conversationId: string): string | null => {
  try {
    return sessionStorage.getItem(nextTurnAgentStorageKey(conversationId));
  } catch {
    return null;
  }
};

export const writeNextTurnAgent = (conversationId: string, agentId: string) => {
  try {
    sessionStorage.setItem(nextTurnAgentStorageKey(conversationId), agentId);
  } catch {
    // Storage unavailable (e.g. private browsing) — the selection just won't
    // survive a refresh.
  }
};
